import $ from "jquery";
const howCanWehelp = {
  methods: {
    tileClickHandler: function () {
     $('.howcanwehelp-card').on('click', function(){
            var pageSection = $('.howcanwehelp-header__title').text().replace(/\n/g, '').trim() ;
            var buttonTitle = $('.card-text').text().replace(/\n/g, '').trim() ;
            var obj = howCanWehelp.methods.dataLayerObj(pageSection,buttonTitle);
            createDataLayer("tileClick", obj);
          });
        },
    dataLayerObj: function (e,el) {
      var obj = {
                     'articleName' : "",
                     'blogCategory' : "",
                     'blogPageCategory' : "",
                     'buttonText' : el ? el : "",
                     'pageSection' :  e ? e : "",
                     'planOption' : "",
                     'pageType' : document.querySelector("meta[name='template']").content == 'chli-clp-template' ? "Campaign":"Other page",
                     'productCategory' : "",
                     'PageSubCategory': "",
                     'productName' : "",
                     'question' : "",
                     'searchTerm' : "",
                     'videoTitle' : "",
                     'bannerName' : "",
                     'bannerType' : "",
                     'leadForm' : "",
                 };
                 return obj;
             },
  },
};

$(document).ready(function () {
  howCanWehelp.methods.tileClickHandler();
});
